import React from "react";

interface TextBlockProps {
  text: string;
  className?: string;
}

const TextBlock: React.FC<TextBlockProps> = ({
  text,
  className = "text-left",
}) => {
  return (
    <div
      className={className}
      style={{ whiteSpace: "pre-line", textAlign: "left" }}
    >
      {text}
    </div>
  );
};

export default TextBlock;
